import { Input, Row } from "antd"

const SearchInput = ({ onSearch, justify, inputRef, noMargin = false, ...props }) => {

  return (
    <Row justify={justify} style={{ marginBottom: !noMargin && '10px' }}>
      <Input.Search
        ref={inputRef}
        style={{ width: props.width ?? 350 }}
        placeholder="Buscar..."
        onSearch={onSearch}
        enterButton
        {...props}
      />
    </Row>
  );
};

export default SearchInput;
